import React, { useEffect } from 'react';
import UserInfo from '../../views/Home/Components/Items/UserInfo';

import { GetOrganizationInfoById } from 'firebaseApis/locations';
import { useDispatch } from 'react-redux';
import { hideLoading, showLoading } from 'reducers/Alerts/AlertActions';

function Header() {
	const [orgData, setOrgData] = React.useState(null);
	const dispatch: any = useDispatch();
	const getOrgData = async () => {
		dispatch(showLoading());
		GetOrganizationInfoById()
			.then((response) => {
				setOrgData(response);
				dispatch(hideLoading());
			})
			.catch(() => {
				dispatch(hideLoading());
			});
	};
	useEffect(() => {
		getOrgData();
	}, []);

	return (
		<div className='relative bg-white p-3 border border-gray-300 shadow rounded-md flex justify-between w-full items-center'>
			<div className='flex justify-center flex-col items-start'>
				{orgData && (
					<div>
						<h1 className='text-2xl font-bold text-gray-500'>
							{orgData.Org_Name?.toUpperCase()}
						</h1>
					</div>
				)}
			</div>
			<UserInfo />
		</div>
	);
}

export default Header;
